export enum ExportEntity {
  QUOTE = 'export_quote',
  QUOTE_LIST = 'export_list',
  QUOTE_PARTS = 'export_parts',
}
